import React from "react";
import Blog_51 from "../component/Blog_51";
function Blog_51_container() {
  return <Blog_51 />;
}

export default Blog_51_container;
